import { useI18n } from "@/shared/hooks";
/**
 * Generates an array of dropdown items based on the provided property name and expected item count.
 * Each item is mapped from Lokalise translations using the property name and index.
 * Example: contact::form::household_type_items_0, contact::form::household_type_items_1, contact::form::household_type_items_2...
 *
 * Note: This function can be extracted from the contacting domain in case it would be needed on other places as it is generic and not
 * tide to any contacting business logic.
 *
 * @param propertyName - The base name for the dropdown items, used for localization.
 * @param expectedItemsCount - The number of items to generate.
 * @returns An array of objects with `id` and `label` properties for each dropdown item.
 */
export function useDropdownItems(propertyName, expectedItemsCount) {
    const { t } = useI18n();
    const result = [];
    for (let index = 0; index < expectedItemsCount; index++) {
        const value = t(propertyName + "_" + index);
        result.push({
            id: (index + 1).toString(),
            label: value,
        });
    }
    return result;
}
